import { INDIVIDUAL } from '@constants/constants';
// Landing page route
export const ONBOARDING_PATH = '/onboarding'

// Auth route
export const LOGIN_PATH = '/login'
export const TOTP_PATH = '/authenticator-challenge'
export const FORGOT_PASSWORD_PATH = '/forgot-password'
export const RESET_PASSWORD_PATH = '/reset-password'
export const USER_ROLE_PATH = '/signup'
export const SIGNUP_PATH = '/signup'
export const OTP_PATH = '/otp'
export const VERIFICATION_PATH = '/verify'
export const APPROVED_PATH = '/approved'
export const NOT_APPROVED_PATH = '/not-approved'
export const REVIEWED_PATH = '/reviewed'

// Protected route
export const DASHBOARD_PATH = '/dashboard'
export const HOSPITAL_DASHBOARD_PATH = '/hospital-dashboard'
export const HOME_PATH = '/'
export const INDIVIDUAL_USER_PATH = '/individual-users'
export const HOSPITAL_USER_PATH = '/hospital-users'
export const NURSE_USER_PATH = '/nurse-users'
export const NOTIFICATION_PATH = '/notification'
export const NOTIFICATION_INDIVIDUAL_PATH = '/notification'
export const ACTIVITY_LOG_PATH = '/device-log'
export const ACTIVITY_LOG_DEVICE_PATH = '/device-log/:id'
// export const DEVICE_LIST_PATH = '/device-list'
export const DEVICE_LIST_PATH = '/active-device'
export const ANALYTICS_PATH = '/analytics'
export const HELP_AND_SUPPORT_PATH = '/help-and-support'
export const MANAGEMENT_PATH = '/management'
export const DEVICE_PATH = '/management/device'
export const DEVICE_DETAIL_PATH = '/management/device/:id'
export const CREATE_DEVICE_PATH = '/management/device/create_device'
export const INDIVIDUAL_DEVICE_PATH = '/device'
export const INDIVIDUAL_DEVICE_DETAIL_PATH = '/device/:id'
export const INDIVIDUAL_CREATE_DEVICE_PATH = '/device/create_device'
export const PATIENT_PATH = '/management/patient'
export const NURSE_PATH = '/management/nurse'
export const NURSE_DETAIL_PATH = '/management/nurse/:id'
export const HOSPITAL_PATH = '/management/hospital-info'
export const CREATE_HOSPITAL_ADMIN_PATH_2 = '/hospital-users/create-admin-user'
export const UPDATE_HOSPITAL_ADMIN_PATH_2 = '/hospital-users/update-admin-user'
export const CREATE_HOSPITAL_ADMIN_PATH = '/management/hospital-info/create-user'

export const NOT_FOUND_PATH = '*'

export const USER_DETAIL_PATH = '/individual-users/:id'
export const HOSPITAL_DETAIL_PATH = '/hospital-users/:id'
export const ADMIN_NURSE_DETAIL_PATH = '/nurse-users/:id'

export const CREATE_USER_PATH = '/individual-users/create-user'
export const CREATE_HOSPITAL_USER_PATH = '/hospital-users/create-user'
export const UPDATE_USER_PATH = '/individual-users/update-user'
export const UPDATE_HOSPITAL_USER_PATH = '/hospital-users/update-user'
export const CREATE_NURSE_PATH = '/management/nurse/create-user'
export const ADMIN_CREATE_NURSE_PATH = '/nurse-users/create-user'
export const UPDATE_NURSE_PATH = '/management/nurse/update-user'

export const CREATE_NOTIFICATION_PATH = '/notification/create-notification'

export const DEVICE_LIST_DETAIL_PATH = '/device-list/device-list-detail-page'

export const REPORT_PATH = '/analytics/report'
export const ASSIGN_PATH = '/assign-device'
export const ASSIGN_LIST_PATH = '/management/assigned-device-list'
export const MANAGEMENT_ASSIGN_PATH = '/management/assign-device'
export const REPORT_LIST_PATH = '/analytics/report-list'

export const SETTING_PATH = '/setting'
export const PROFILE_PATH = '/profile'
export const CHANGE_PASSWORD_PATH = '/change-password'
export const PROFILE_RESET_PASSWORD_PATH = '/profile-reset-password'

export const AUDIT_LOG_PATH = '/audit-log'

export const TERMS_AND_CONDITIONS_PATH = '/terms-and-conditions'
export const PRIVACY_POLICY_PATH = '/privacy-policy'